interface AdminSparkProps {
	data?: number[];
	color?: string;
}

const DEFAULT_DATA = [3, 5, 4, 7, 6, 8, 7, 9, 8, 11, 10, 12];

export function AdminSpark({
	data = DEFAULT_DATA,
	color = "currentColor",
}: AdminSparkProps) {
	const max = Math.max(...data);
	const min = Math.min(...data);
	const w = 60;
	const h = 24;
	const pts = data
		.map((v, i) => {
			// Un point unique : pas d'intervalle à diviser.
			const x = data.length > 1 ? (i / (data.length - 1)) * w : 0;
			const y = h - ((v - min) / (max - min || 1)) * (h - 2) - 1;
			return `${x.toFixed(1)},${y.toFixed(1)}`;
		})
		.join(" ");
	return (
		<svg className="kpi-spark" viewBox={`0 0 ${w} ${h}`}>
			<polyline
				points={pts}
				fill="none"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
